import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { CardShell } from '@/components/frontend/atoms/content/CardShell'
import { CardBody } from '@/components/frontend/atoms/content/CardBody'
import { CheckItem } from '@/components/frontend/atoms/content/CheckItem'
import { ContactInfoItem } from '@/components/frontend/atoms/content/ContactInfoItem'
import { Eyebrow } from '@/components/frontend/atoms/typography/Eyebrow'
import { InfoAlert } from '@/components/frontend/atoms/feedback/InfoAlert'
import { CONTACT_EMAIL, LINKEDIN_URL, LINKEDIN_LABEL } from '@/lib/contact'
import { useTranslation } from '@/hooks/useTranslation'

const FIRST_CALL_ITEMS = ['item_problem', 'item_solution', 'item_next'] as const

export const ContactInfo: React.FC = () => {
  const { t } = useTranslation()

  return (
    <CardShell>
      <CardBody padding="lg">
        <Stack gap="6">
          <Stack gap="4">
            <Eyebrow tone="primary">{t('contact.includes_title')}</Eyebrow>
            <Stack gap="3">
              {FIRST_CALL_ITEMS.map((key) => <CheckItem key={key}>{t(`contact.${key}`)}</CheckItem>)}
            </Stack>
          </Stack>
          <Stack gap="4">
            <ContactInfoItem icon="mail" label={t('contact.email_label')} value={CONTACT_EMAIL} href={`mailto:${CONTACT_EMAIL}`} />
            <ContactInfoItem icon="linkedin" label={t('contact.linkedin_label')} value={LINKEDIN_LABEL} href={LINKEDIN_URL} />
            <ContactInfoItem icon="location" label={t('contact.location_label')} value={t('contact.location_value')} />
          </Stack>
          <InfoAlert>{t('contact.response_time')}</InfoAlert>
        </Stack>
      </CardBody>
    </CardShell>
  )
}
